<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :key="key"
    :help="true"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    id: {},
    customerFullObject: {},
    defaultFullObject: {},
  },
  emits: ['input', 'update:fullObject'],
  data() {
    return {
      key: 1,
    }
  },
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return typeof this.value === 'string' ? Number(this.value) : this.value
    },
  },
  watch: {
    customerFullObject: {
      immediate: true,
      handler(newValue) {
        const marketingUser = newValue?.marketing_user

        if (marketingUser?.id != null) {
          this.emitSelectedMarketingUser(marketingUser)
          return
        }

        if (this.defaultFullObject?.id != null) {
          this.emitSelectedMarketingUser(this.defaultFullObject)
          return
        }

        this.$emit('input', null)
        this.$emit('update:fullObject', {})
        this.key += 1
      },
    },
  },
  methods: {
    emitSelectedMarketingUser(marketingUser) {
      this.$emit('input', Number(marketingUser.id))
      this.$emit('update:fullObject', marketingUser)
      this.key += 1
    },
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
